import { Component, Input } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { PartnerQueryStatus } from 'src/app/core/models/PartnerQueryStatus';
import { QueryDetailModel } from 'src/app/core/models/QueryDetailModel';
import { QueryStatus } from 'src/app/core/models/QueryStatus';
import { User } from 'src/app/core/models/user';
import { UserService } from 'src/app/core/services/user.service';
import { ViewAttachmentsComponent } from '../view-attachments/view-attachments.component';
import { openViewAttachmentsModal, openViewCommentsModal } from '../Shared/CommonHelper';

@Component({
  selector: 'app-query-detail-info',
  standalone: false,
  templateUrl: './query-detail-info.component.html',
  styleUrl: './query-detail-info.component.less'
})
export class QueryDetailInfoComponent {
  @Input() queryDetail!: QueryDetailModel;
  @Input() partnerUserMaster: { item_id: any; item_text: any }[] = [];
  @Input() CCSubDepartmentsMaster: { item_id: any; item_text: any }[] = [];
  @Input() requestStatus = '';
  @Input() Subject: string ='';

  queryStatus: QueryStatus = QueryStatus.New;
  partnerQueryStatus: PartnerQueryStatus =  PartnerQueryStatus.New;
  dropdownSettings = {};
  selectedCCUsers = [];
  selectedCCSubDepts: { item_id: any; item_text: any }[] = [];

  isCategoryCommentVisible = false;
  isContractNumberVisible = false;
  isAFEVisible = false;
  isWOVisible = false;

  partnerUploadedAttachmtCnt = 0;
  internalUserUploadedAttachmtCnt = 0;

  currentUser: User = new User();

  constructor(
    private userService: UserService,
    private modalService: NzModalService,
  ) {}

  ngOnInit() {
    this.currentUser = this.userService.getCurrentUser();
    if (this.currentUser?.User_Code == null) {
      window.location.href = '/';
    }
    this.initialiseData();
    
    if (this.queryDetail.CCUsers) {
      // for (var i = 0; i < this.queryDetail.CCUsers.length; i++) {
      //   this.selectedCCUsers.push(this.partnerUserMaster.filter(s => s["item_id"] == this.queryDetail.CCUsers[i])[0]);
      // }
      this.selectedCCUsers = this.queryDetail.CCUsers;
    }
    this.selectedCCSubDepts = this.queryDetail.CCSubDepartments??[];
    // if (this.queryDetail.CCSubDepartments) {
    //   for (var i = 0; i < this.queryDetail.CCSubDepartments.length; i++) {
    //     this.selectedCCSubDepts.push(this.CCSubDepartmentsMaster.filter(s => s["item_id"] == this.queryDetail.CCSubDepartments[i])[0]);
    //   }
    // }
  }

  initialiseData() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
    };

    if (this.queryDetail.Clarification_SubCat_Code == '0' || this.queryDetail.Clarification_SubCat_Code == undefined
      || this.queryDetail.Clarification_SubCat_Code == null) {
      this.queryDetail.Clarification_SubCat_Code = '';
    }
    this.setSubCategoryVisibility(this.queryDetail.Clarification_SubCat_Code);
    this.partnerUploadedAttachmtCnt = this.queryDetail.FileAttachments.filter(s => s.Partner_UploadedFile).length;
    this.internalUserUploadedAttachmtCnt = this.queryDetail.FileAttachments.filter(s => !s.Partner_UploadedFile).length;
  }

  setSubCategoryVisibility(SubCategory_Code: string) {
    switch (SubCategory_Code.toString()) {
      case "1":
      case "5":
        this.isContractNumberVisible = true;
        break;
      case "2":
      case "6":
        this.isAFEVisible = true;
        break;
      case "3":
      case "7":
        this.isWOVisible = true;
        break;
      case "4":
      case "8":
        this.isCategoryCommentVisible = true;
        break;
    }
  }

  viewAttachments(viewPartnerUploadedFiles: boolean) {    
    openViewAttachmentsModal(this.modalService, this.queryDetail, viewPartnerUploadedFiles);
  }

  viewComments() {
    openViewCommentsModal(this.modalService, this.queryDetail.Query_Reference_Number, this.queryDetail.ConsolidatedComment);
  //   const modalRef = this.modalService.open(ViewCommentsComponent, {
  //     backdrop: 'static',
  //     keyboard: false,
  //     size: 'lg'
  //   });
  //   modalRef.componentInstance.queryComments = this.queryDetail.ConsolidatedComment;
  //   modalRef.componentInstance.queryReferenceNumber = this.queryDetail.Query_Reference_Number;
  //   modalRef.result.then((result) => {
  //     modalRef.dismiss();
  //   }, (reason) => {
  //     console.log(reason);
  //   });
   }
}
